import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { RadioCard } from '@hero/components/atoms';

const InfoHeaderWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

const PaymentMethodArea = styled.div`
  display: grid !important;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);
`;

const PaymentMethodItem = styled(RadioCard)`
  min-width: 100%;
  padding-left: 40px;
`;

const EmptyTableTitle = styled(Typography)`
  margin-bottom: 8px;
`;

const EmptyTableDescription = styled(Typography)`
  margin-bottom: 40px;
  text-align: center;
  width: 400px;
`;

const EmptyArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 80px 0;

  button {
    font-size: 14px;
  }
`;

const EmptyAreaText = styled(Typography)`
  margin-bottom: 16px;
  text-align: center;
  width: 200px;
`;

export {
  EmptyArea,
  EmptyAreaText,
  EmptyTableDescription,
  EmptyTableTitle,
  InfoHeaderWrapper,
  PaymentMethodArea,
  PaymentMethodItem
};
